export const PUBLIC_REDUCED_LAYOUT = 'PublicReducedLayout'
export const PUBLIC_REDUCED_LAYOUT_DYNAMIC = 'PublicReducedLayoutDynamic'
export const PUBLIC_EXTENDED_LAYOUT = 'PublicExtendedLayout'
export const PUBLIC_LAYOUT = 'PublicLayout'
export const PUBLIC_MENU_LAYOUT = 'PublicMenuLayout'
export const PUBLIC_MOBILE_MENU_LAYOUT = 'PublicMobileMenuLayout'
export const BASE_LAYOUT = 'BaseLayout'
export const FORUM_NAVBAR_LAYOUT = 'ForumNavbar'
export const INTERNAL_REDUCED_LAYOUT = 'InternalReducedLayout'
export const HEALTHY_HABITS_LAYOUT = 'HealthyHabitsLayout'
export const PRIVATE_LAYOUT = 'PrivateLayout'
export const PUBLIC_MENU_LAYOUT_V2 = 'PublicMenuLayoutV2'
export const OPENSALUD_EMPRESAS_LAYOUT = 'OpensaludEmpresasLayout'
export const OPENSALUD_LAYOUT = 'OpensaludLayout'
export const OPENSALUD_360_LAYOUT = 'Opensalud360Layout'
export const OPENSALUD_PACIENTES_LAYOUT = 'OpensaludPacientesLayout'
export const OPENSALUD_PROFESIONALES_LAYOUT = 'OpensaludProfesionalesLayout'
export const BACK_BTN_LAYOUT = 'BackBtnLayout'


// WEBPACK FOOTER //
// ./src/constants/layouts.js